export default "__VITE_ASSET__A8oKM5Mi__"